import React, {Component} from 'react'
import {FormattedDate, FormattedMessage, FormattedNumber} from 'react-intl'
import {AppContext} from '@lightspeed-invoicing/core-client/frontend'
import Icon from "../common/icon/icon.component.jsx";
import StandardList from "../common/listing/list.component.jsx";
import { GoogleLogin, GoogleLogout } from 'react-google-login';

class SpiffLeaderboard extends Component {

    constructor(props, context) {
        super(props, context)
        this.handleFormChange = this.handleFormChange.bind(this)

        this.state = {
            loading: true,
            first: '',
            second: '',
            third: '',
            active: '',
            username: '',
            errorMessage: '',
            rows: [],
            headers: [],
            data: {},
            isSignedIn: false,
            isAuthorized: false,
        }
        this.onGoogleLoginSuccess = this.onGoogleLoginSuccess.bind(this)
        this.onGoogleLogoutSuccess = this.onGoogleLogoutSuccess.bind(this)
        this.onGoogleLoginFailure = this.onGoogleLoginFailure.bind(this)
    }

    componentDidMount() {}

    onGoogleLogoutSuccess() {
        this.setState({
            isSignedIn: false,
            loading: false,
            data: {},
            rows: [],
            headers: [],
            username: '',
            errorMessage: '',
        })
    }

    verifyEmail(email) {
        return email.endsWith('@lightspeedhq.com') || email.endsWith('@quotemachine.com')
    }

    onGoogleLoginFailure(error) {
        if (error) {
            this.setState({
                errorMessage: error.details,
            })
        }
    }

    onGoogleLoginSuccess(user) {
        if (user) {
            const profile = user.getBasicProfile()
            if (!this.verifyEmail(profile.getEmail())) {
                this.setState({
                    isSignedIn: true,
                    isAuthorized: false,
                    username: profile.getName(),
                    errorMessage: '',
                })
                return
            }
            AppContext.getApiClient().get('/admin/spiff-leader-board').then(res => {
                let keys = Object.keys(res)
                let first = keys.pop()
                this.setState({
                    first: first,
                    active: first,
                    second: keys.pop(),
                    third: keys.pop(),
                    rows: Object.values(res[first] || {}).map(r => this.row(r)),
                    data: res,
                    headers: this.headers(),
                    loading: false,
                    isSignedIn: true,
                    isAuthorized: true,
                    username: profile.Ad,
                    errorMessage: '',
                })
            })
        } else {
            this.setState({
                isSignedIn: false,
                loading: false,
                isAuthorized: false,
                username: '',
            })
        }
    }

    changeTab(val) {
        return function (e) {
            e.preventDefault()
            this.setState({
                active: val,
                rows: Object.values(this.state.data[val] || {}).map(r => this.row(r)),
            })
        }.bind(this)
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    headers() {
        return [
            <FormattedMessage
                id="lightspeed.leaderboard.headers.sales_rep_name_label"
                defaultMessage="Sales rep"
            />,
            <FormattedMessage
                id="lightspeed.leaderboard.headers.number_of_lead_label"
                defaultMessage="Number of leads referred"
            />,
        ]
    }

    row(rep) {
        return {
            data: [
                rep.name,
                <div>
                    <div className={' w-100 d-flex mb-0 justify-content-between'}>
                        <div>
                            <strong>
                                {rep.numberOfLead}
                                {rep.numberOfWon > 0 && <small className={'ml-3 text-success'}><FormattedMessage
                                    id="lightspeed.leaderboard.headers.number_of_won_label"
                                    defaultMessage="{won} won"
                                    values={{
                                        won: rep.numberOfWon
                                    }}
                                /></small>}
                            </strong>
                        </div>
                        <div>
                            <a className="btn btn-primary btn-sm" data-toggle="collapse" href={'#listOfLeads_' + rep.id} role="button"
                               aria-expanded="false" aria-controls="collapseExample" >
                                <Icon value={'eye'} className={'mr-1'}/>
                                <FormattedMessage
                                    id="lightspeed.leaderboard.headers.more_details_label"
                                    defaultMessage="See leads"
                                />
                            </a>
                        </div>

                    </div>
                    <div className="collapse mt-2" id={'listOfLeads_' + rep.id}>
                        <div className="card card-body pb-2">
                            {rep.leads.map((lead, key) => {
                                let className = 'badge badge-primary'
                                switch (lead.status) {
                                    case 'won':
                                        className = 'badge badge-success'
                                        break
                                    case 'lost':
                                        className = 'badge badge-danger'
                                        break
                                }
                                return <div className={'w-100'} key={key}>
                                    <small className={'mr-2'}>
                                        <FormattedDate
                                            year='numeric'
                                            month='long'
                                            day='numeric'
                                            value={new Date(lead.createdAt)}/>
                                        :
                                    </small>
                                    <strong>{lead.company}</strong>
                                    <span className={'ml-3 ' + className}>{lead.status}</span>
                                    {lead.referralSpiffPaid && <span className={'ml-2 badge badge-info'}><FormattedMessage
                                        id="lightspeed.leaderboard.headers.referral_spiff_paid_label"
                                        defaultMessage="Referral SPIFF Paid"
                                    /></span>}
                                    {lead.activationSpiffPaid && <span className={'ml-2 badge badge-info'}><FormattedMessage
                                        id="lightspeed.leaderboard.headers.activation_spiff_paid_label"
                                        defaultMessage="Activation SPIFF Paid"
                                    /></span>}
                                </div>
                            })}
                            <div className={'w-100 mt-3 text-secondary'}>
                                <small><FormattedMessage
                                    id="lightspeed.leaderboard.lead_is_not_here_label"
                                    defaultMessage="You don't see your lead here? Make sure you clicked on the 'outbound referral' button from SalesForce."
                                /></small>
                            </div>
                        </div>
                    </div>
                </div>,
            ],
            classNames: [
                'w-25',
                'w-75',
            ]
        }
    }


    render() {

        return <div className="row ui-has-modules justify-content-md-center">
            {this.state.redirect}
            <div className="col-12 mt-4">
                <h1 className="text-align-center custom-lead d-flex justify-content-center align-items-center border-bottom pb-3">
                    <img src='/images/QuoteM_horizontal_flat.png' height='80px'/>
                    <span className={'pl-4 ml-2 border-left'}>
                        <FormattedMessage
                            id="lightspeed.leaderboard.title"
                            defaultMessage="Lead Status"
                        />
                    </span>
                </h1>
            </div>
            <div className={'col-md-12 col-lg-8 text-center py-3'}>
                {this.state.isSignedIn && this.state.isAuthorized && <a href={'https://www.quotemachine.com/en/lightspeed-sales-sheet/'} className={'btn btn-custom-primary mr-3'}>
                    <FormattedMessage
                        id="lightspeed.leaderboard.spiff_program_details_btn"
                        defaultMessage="SPIFF Program Details"
                    />
                </a>}
                {this.state.isSignedIn && !this.state.isAuthorized && <strong className={'text-danger mr-3'}>
                    <FormattedMessage
                        id="lightspeed.leaderboard.access_denied_message"
                        defaultMessage="Access Denied."
                    />
                </strong>}
                {this.state.errorMessage && <strong className={'text-danger mr-3'}>
                    {this.state.errorMessage}
                </strong>}
                {this.state.isSignedIn ? <GoogleLogout
                    clientId="62896823907-o8e0n7st99ndobgofrjivgnnhgv0o3kb.apps.googleusercontent.com"
                    buttonText={"Logout "+ this.state.username}
                    onLogoutSuccess={this.onGoogleLogoutSuccess}
                >
                </GoogleLogout> : <GoogleLogin
                    clientId="62896823907-o8e0n7st99ndobgofrjivgnnhgv0o3kb.apps.googleusercontent.com"
                    buttonText="Login"
                    onSuccess={this.onGoogleLoginSuccess}
                    onFailure={this.onGoogleLoginFailure}
                    cookiePolicy={'single_host_origin'}
                    isSignedIn={true}
                />}
            </div>
            {new Date('2020-12-06') > new Date() &&this.state.isSignedIn && this.state.isAuthorized && <div className="col-md-12 col-lg-8 mt-2">
                <div className="row">
                    <div className="col-12">
                        <div className="alert alert-success" role="alert">
                            <Icon value={'gift'} className={'mr-1'}/><strong className={'strong'}>Update (November 12th, 2020): $15 for a referral and $100 for a conversion until December 5th, 2020</strong>
                            <br />
                            <small>This month and until December 5th, 2020, every new referral
                            will get you $15 credited, these $15 will turn into $100 if the lead is successfully
                                converted.</small>
                        </div>
                        <div className="alert alert-warning" role="alert">
                            <Icon value={'exclamation-triangle'} /> <strong>No blind leads.</strong> You must obtain the merchant’s consent to be contacted by
                            QuoteMachine before sending the referral.
                            <br />
                            <small>A merchant can’t be submitted multiple times,
                            merchants that are already in our database will be ignored. If we sense the spiff is being
                                abused, we can suspend your participation in the program.</small>
                        </div>
                    </div>
                </div>
            </div>}

            {this.state.isSignedIn && this.state.isAuthorized && <div className={'col-md-12 col-lg-8'}>
                <ul className="nav nav-tabs">
                    <li className="nav-item">
                        <a onClick={this.changeTab(this.state.third)} className={"nav-link " + (this.state.third === this.state.active ? 'active' : '')} href="#">{this.state.third}</a>
                    </li>
                    <li className="nav-item">
                        <a onClick={this.changeTab(this.state.second)} className={"nav-link " + (this.state.second === this.state.active ? 'active' : '')} href="#">{this.state.second}</a>
                    </li>
                    <li className="nav-item">
                        <a onClick={this.changeTab(this.state.first)} className={"nav-link " + (this.state.first === this.state.active ? 'active' : '')} href="#">{this.state.first}</a>
                    </li>
                </ul>
            </div>}
            {this.state.rows.length > 0 && <div className="col-md-12 col-lg-8">
                <div className="row">
                    <div className="col-12">
                        <StandardList
                            smallLine={true}
                            className="row pt-0"
                            headers={this.state.headers}
                            rows={this.state.rows}
                        />
                    </div>
                </div>
            </div>}

        </div>
    }
}

export default SpiffLeaderboard





// WEBPACK FOOTER //
// ./src/staff/leaderboard.component.jsx